<ng-template #loading_local_media>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>



<compass-local-media-form *ngIf="localMedia$ | async as localMedia; else loading_local_media" [setup]="localMedia"
    style="width: 100%;"></compass-local-media-form>

<compass-local-media-accordion></compass-local-media-accordion>